import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getPathLanguage } from '../../../../utils/params';
// import { Subtract } from 'assets/images/web-isn';
import { useTranslation } from 'react-i18next';

const HelpsMenu = () => {
  const pathLanguage = getPathLanguage(useLocation());
  const location = useLocation();
  const { t } = useTranslation();
  const [isScrollUp, setIsScrollUp] = useState(false);
  const prevScrollY = useRef(0);
  
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    prevScrollY.current >= 430 ? setIsScrollUp(true) : setIsScrollUp(false);
    prevScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [prevScrollY]);

  return (
    <div id="servicedOfficeMenu" className={`${isScrollUp ? 'servicedOffice' : 'servicedOfficeHide'}`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 py-3">
            <ul className="d-flex">
              <li className="text-black ">
                <Link
                  className={location.pathname.includes(`/frequently-asked-issues`) ? 'link-helps-active' : ''}
                  to={`${pathLanguage}/helps/frequently-asked-issues`}
                >
                  {t('helps.frequently_asked_issues')}
                </Link>
              </li>
              <li className="pl-4 ml-2 text-black">
                <Link
                  className={location.pathname.includes(`/create-issue`) ? 'link-helps-active' : ''}
                  to={`${pathLanguage}/helps/create-issue`}
                >
                  {t('helps.create_issue_breadscrum')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpsMenu;
